import React, { useState } from 'react'
import { Layout, Menu, Drawer, Button, Dropdown, Space } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  DashboardOutlined,
  UserOutlined,
  KeyOutlined,
  CalendarOutlined,
  MessageOutlined,
  FireOutlined,
  DollarOutlined,
  FlagOutlined,
  BarChartOutlined,
  SettingOutlined,
  LogoutOutlined,
  MenuOutlined,
  DownOutlined,
  SmileOutlined
} from '@ant-design/icons'
import { useAuth } from '../context/AuthContext'
import { siderItems, itemRoutes, findKeyForRoute, getOpenKeys } from './menuConfig'

const { Header } = Layout

const quickItems = [
  { key: '/dashboard', icon: <DashboardOutlined />, label: 'Inicio' },
  { key: '/clients', icon: <UserOutlined />, label: 'Alumnas' },
  { key: '/classes', icon: <CalendarOutlined />, label: 'Agenda' },
  { key: '/mensajes', icon: <MessageOutlined />, label: 'Mensajes' }
]

const moreItems = [
  { key: '/usuarios', icon: <KeyOutlined />, label: 'Usuarios y Claves' },
  { key: '/rutinas', icon: <FireOutlined />, label: 'Rutinas' },
  { key: '/payments', icon: <DollarOutlined />, label: 'Pagos' },
  { key: '/objetivos', icon: <FlagOutlined />, label: 'Objetivos' },
  { key: '/reportes', icon: <BarChartOutlined />, label: 'Reportes' },
  { key: '/bienestar', icon: <SmileOutlined />, label: 'Bienestar' },
  { type: 'divider' },
  { key: '/configuracion', icon: <SettingOutlined />, label: 'Configuración' }
]

const drawerItems = siderItems

function Navbar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, logout } = useAuth()
  const [drawerOpen, setDrawerOpen] = useState(false)

  const handleNavigate = (key) => {
    const route = itemRoutes[key]
    if (route) navigate(route)
    setDrawerOpen(false)
  }

  return (
    <>
      <Header style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: 'rgba(20,20,20,0.85)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.2)',
        padding: '0 12px',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        height: 52
      }}>
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          onClick={() => navigate('/dashboard')}
        >
          <img src="/logobox.jpg" alt="" style={{ width: 30, height: 30, borderRadius: '50%', objectFit: 'cover', marginRight: 8 }} />
          <div>
            <div style={{ color: '#ffffff', fontSize: 16, fontWeight: 'bold', textShadow: '0 0 10px rgba(255,255,255,0.5)', lineHeight: 1.1 }}>ESPÍRITU LIBRE</div>
            <div style={{ color: '#E0B34A', fontSize: 10, letterSpacing: 1.5, fontWeight: 600 }}>Panel de administración</div>
          </div>
        </div>

        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={quickItems}
          onClick={({ key }) => navigate(key)}
          className="desktop-menu"
          style={{ flex: 1, background: 'transparent', borderBottom: 'none', marginLeft: 16, minWidth: 0 }}
        />

        <Dropdown
          className="desktop-menu"
          menu={{
            items: moreItems,
            selectedKeys: moreItems.some(i => i.key === location.pathname) ? [location.pathname] : [],
            onClick: ({ key }) => navigate(key)
          }}
          trigger={['click']}
        >
          <Space style={{ color: '#ffffff', cursor: 'pointer', padding: '0 8px', fontSize: 14 }}>
            Más <DownOutlined style={{ fontSize: 11 }} />
          </Space>
        </Dropdown>

        <Button
          type="text"
          icon={<MenuOutlined style={{ color: 'white', fontSize: 20 }} />}
          onClick={() => setDrawerOpen(true)}
          className="mobile-menu-btn"
          style={{ padding: 4 }}
        />

        <LogoutOutlined
          onClick={logout}
          className="desktop-menu"
          style={{ color: 'white', fontSize: 16, cursor: 'pointer', marginLeft: 12 }}
        />
      </Header>

      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => { navigate('/dashboard'); setDrawerOpen(false) }}>
            <img src="/logobox.jpg" alt="" style={{ width: 26, height: 26, borderRadius: '50%', objectFit: 'cover', marginRight: 8 }} />
            <span style={{ fontWeight: 'bold' }}>ESPÍRITU LIBRE</span>
          </div>
        }
        placement="left"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={250}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="vertical"
          selectedKeys={findKeyForRoute(location.pathname) ? [findKeyForRoute(location.pathname)] : []}
          defaultOpenKeys={getOpenKeys(findKeyForRoute(location.pathname))}
          items={drawerItems}
          onClick={({ key }) => handleNavigate(key)}
          style={{ border: 'none', fontSize: 15 }}
        />
        <div style={{ padding: '16px 20px', borderTop: '1px solid #f0f0f0', marginTop: 12 }}>
          <div style={{ marginBottom: 10, color: '#666', fontSize: 13 }}>
            {user?.name || user?.username}
          </div>
          <Button danger icon={<LogoutOutlined />} onClick={() => { logout(); setDrawerOpen(false) }} block size="small">
            Cerrar Sesión
          </Button>
        </div>
      </Drawer>

      <style>{`
        .desktop-menu { display: flex !important; }
        .mobile-menu-btn { display: none !important; }

        @media (max-width: 992px) {
          .desktop-menu { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
        }
      `}</style>
    </>
  )
}

export default Navbar
